<template>
  <v-card dark class="d-flex flex-column" style="height: 100vh">
    <v-card-title class="black white--text">
      <span class="yellow--text mr-2">HYROX</span> Admin
      <v-spacer></v-spacer>
      <v-btn icon dark @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>

    <v-card-text class="pa-4">
      <v-data-table :headers="headers" :items="reservations" :search="search" class="elevation-1">
        <template v-slot:top>
          <v-text-field v-model="search" label="Suche" class="mx-4" append-icon="mdi-magnify"></v-text-field>
        </template>

        <template v-slot:item.createdBy="{ item }">
          <div v-if="item.createdBy">
            <strong>{{ item.createdBy.vorname }} {{ item.createdBy.nachname }}</strong
            ><br />
            <small>{{ item.createdBy.email }}</small>
          </div>
          <div v-else>Unbekannt</div>
        </template>

        <template v-slot:item.content.ticketDivision="{ item }">
          <v-chip x-small color="grey darken-3" dark>{{ item.content.ticketDivision }}</v-chip>
        </template>

        <template v-slot:item.content.ticketPrice="{ item }"> CHF {{ item.content.ticketPrice }} </template>

        <template v-slot:item.content.status="{ item }">
          <v-chip :color="getStatusColor(item.content.status)" dark small>
            {{ formatStatus(item.content.status) }}
          </v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
          <!-- Bezahlt markieren (wenn reserviert) -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small @click="updateStatus(item, 'paid')" v-if="item.content.status === 'reserved'" v-bind="attrs" v-on="on">
                <v-icon color="green">mdi-cash-check</v-icon>
              </v-btn>
            </template>
            <span>Als Bezahlt markieren</span>
          </v-tooltip>

          <!-- Verschickt markieren (wenn bezahlt) -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small @click="updateStatus(item, 'collected')" v-if="item.content.status === 'paid'" v-bind="attrs" v-on="on">
                <v-icon color="blue">mdi-email-fast-outline</v-icon>
              </v-btn>
            </template>
            <span>Als Verschickt markieren</span>
          </v-tooltip>

          <!-- Stornieren (wenn nicht bereits storniert) -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                @click="updateStatus(item, 'canceled')"
                color="red"
                v-if="item.content.status !== 'canceled'"
                v-bind="attrs"
                v-on="on">
                <v-icon>mdi-cancel</v-icon>
              </v-btn>
            </template>
            <span>Stornieren / Freigeben</span>
          </v-tooltip>

          <!-- Wiederherstellen (wenn storniert) -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                @click="updateStatus(item, 'reserved')"
                color="orange"
                v-if="item.content.status === 'canceled'"
                v-bind="attrs"
                v-on="on">
                <v-icon>mdi-restore</v-icon>
              </v-btn>
            </template>
            <span>Wiederherstellen (Reserviert)</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import api from "@/api"

export default {
  data: () => ({
    search: "",
    reservations: [],
    headers: [
      { text: "Kunde", value: "createdBy" },
      { text: "Ticket", value: "content.ticketDivision" },
      { text: "Preis", value: "content.ticketPrice" },
      { text: "Status", value: "content.status" },
      { text: "Datum", value: "created" },
      { text: "Actions", value: "actions", sortable: false },
    ],
  }),
  async created() {
    this.reservations = await api.getHyroxAdminReservations()
  },
  methods: {
    formatStatus(status) {
      if (status === "collected") return "VERSCHICKT"
      if (status === "canceled") return "STORNIERT"
      if (status === "paid") return "BEZAHLT"
      if (status === "reserved") return "RESERVIERT"
      return status.toUpperCase()
    },
    getStatusColor(status) {
      if (status === "reserved") return "orange"
      if (status === "paid") return "green"
      if (status === "collected") return "blue"
      return "red"
    },
    async updateStatus(item, status) {
      let msg = `Status auf ${status} setzen?`
      if (status === "collected") msg = "Ticket als VERSCHICKT markieren?"
      if (status === "canceled") msg = "Reservierung wirklich STORNIEREN? Das Ticket wird wieder für den Verkauf freigegeben."

      if (!confirm(msg)) return

      await api.updateHyroxStatus(item._id, status)
      this.reservations = await api.getHyroxAdminReservations() // Reload
    },
  },
}
</script>
